
import React from 'react';
import PropTypes from 'prop-types';

import {TextCharLimit} from 'views/components';

import {translate} from 'views/module';

const ContentEdit = (props) => {
  const bioQuestion = props.bioQuestion;
  const updateQuestionData = props.updateQuestionData;

  const {bioQuestionId, questionData} = bioQuestion;

  const handleChange = (value) => {
    updateQuestionData({
      value,
    });
  };

  return (
    <TextCharLimit
      label={translate(`caregiver.CaregiverDetail.Biography.Questions.Titles.${bioQuestionId}`)}
      value={questionData.value}
      onChange={handleChange}
      charLimit={100}
    />
  );
};

ContentEdit.propTypes = {
  bioQuestion: PropTypes.shape({
    bioQuestionId: PropTypes.string.isRequired,
    questionData: PropTypes.shape({
      value: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  updateQuestionData: PropTypes.func.isRequired,
};

export default ContentEdit;
